var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94944 14.9242C8.66292 15.0253 8.19101 15.0253 7.90449 14.9242C5.46067 14.0899 0 10.6096 0 4.71067C0 2.10674 2.09831 0 4.68539 0C6.2191 0 7.57584 0.741573 8.42697 1.88764C9.27809 0.741573 10.6433 0 12.1685 0C14.7556 0 16.8539 2.10674 16.8539 4.71067C16.8539 10.6096 11.3933 14.0899 8.94944 14.9242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHeart);
export default __webpack_public_path__ + "static/media/white-heart.dca50c02a62cb52ff670aff19526532f.svg";
export { ForwardRef as ReactComponent };